export default __webpack_public_path__ + "static/7-bf7d5deacf28500d3f1bc6b9e477e883.png";